import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Youtube, Instagram, Video } from 'lucide-react';
import { mockData } from '../mock';

export const Footer = () => {
  const iconMap = {
    Facebook: Facebook,
    Youtube: Youtube,
    Instagram: Instagram,
    Video: Video
  };

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4 group">
              <div className="bg-white rounded-lg p-2 inline-block">
                <img 
                  src="https://customer-assets.emergentagent.com/job_2343b8d4-bf7c-477c-9f5a-ad0017c87460/artifacts/jta8nfui_IMG_1207.jpeg" 
                  alt="Top Driver Driving School" 
                  className="h-12 w-auto transform group-hover:scale-105 transition-transform duration-200"
                />
              </div>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Professional driving instruction from certified experts. Building safe and confident drivers since 2021.
            </p>
            {/* Social Media Icons */}
            <div className="flex space-x-4">
              {mockData.socialMedia.map((social) => {
                const Icon = iconMap[social.icon];
                return (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors duration-200 group"
                    aria-label={social.name}
                  >
                    <Icon className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors duration-200" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {mockData.navigation.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    className="text-gray-400 hover:text-red-600 text-sm transition-colors duration-200"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" />
                <span className="text-gray-400 text-sm">{mockData.contact.phone}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" />
                <span className="text-gray-400 text-sm">{mockData.contact.email}</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" />
                <span className="text-gray-400 text-sm">
                  {mockData.contact.address}<br />
                  {mockData.contact.city}
                </span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Office Hours</h3>
            <div className="flex items-start space-x-3">
              <Clock className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0" />
              <span className="text-gray-400 text-sm">{mockData.contact.hours}</span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center space-y-2">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Top Driver Driving School. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs">
            Website designed & developed by{' '}
            <a
              href="https://inventiveapps.co.uk"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-red-600 transition-colors duration-200"
            >
              Inventive Apps LTD
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};